/**
 * @file IconLoadMore Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-load-more',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.75}"
  >
    <g
      stroke=""
      stroke-width="${data.strokeWidth * 1.5}"
      transform="translate(-900,-1209)"
    >
      <circle cx="924" cy="1233" r="21" />
    </g>
  </g>
</svg>
`
);
